import { useMemo } from "react";

import {
    PrincipalCollateralPair,
    useLoopscaleWalletContext,
    useUserLoops,
    LoopExpanded,
    LoopPositionExpanded
} from "@bridgesplit/abf-react";
import { Column, Text } from "@bridgesplit/ui";
import { useLoopsPagination } from "app/api";
import { PositionsTable } from "app/components/common";
import { COPY } from "app/constants";
import { getLoopDetailColumnDefs } from "app/components/portfolio/LoopsSection";
import { useAppDialog } from "app/utils";

import { useLoopContext } from "../LoopContext";

export default function UserLoopPositions() {
    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();
    const { loopExpanded } = useLoopContext();
    const { open } = useAppDialog();
    const pagination = useLoopsPagination();
    const loopVaultPrincipalCollateralPairs = getLoopVaultPrincipalCollateralPairs(loopExpanded);

    const {
        data: userLoops,
        totalCount,
        isLoading,
        isFetching
    } = useUserLoops({
        pagination: pagination.backendPagination,
        skip: !activeWallet || !loopVaultPrincipalCollateralPairs,
        loopVaultPrincipalCollateralPairs
    });
    const { visibleData } = pagination;
    const items = useMemo(() => visibleData(userLoops), [visibleData, userLoops]);
    const columns = useMemo(() => getLoopDetailColumnDefs(open), [open]);

    return (
        <Column spacing={2}>
            <Text variant="h3"> My positions </Text>

            <PositionsTable<LoopPositionExpanded>
                items={items}
                columns={columns}
                getRowKey={(loop) => loop.loanExpanded.loan.address}
                page={pagination.params.page}
                setPage={pagination.setPage}
                pageSize={pagination.params.pageSize}
                totalCount={totalCount}
                emptyPlaceholder={`You don't have any ${COPY.LOOP_TERM_PLURAL}`}
                loading={isLoading || isFetching}
            />
        </Column>
    );
}

function getLoopVaultPrincipalCollateralPairs(
    loopExpanded: LoopExpanded | undefined
): PrincipalCollateralPair[] | undefined {
    if (!loopExpanded) return undefined;
    return [
        {
            principalAssetIdentifier: loopExpanded.principalToken.mint,
            collateralAssetIdentifier: loopExpanded.collateralToken.mint
        }
    ];
}
